import { useSyncExternalStore } from 'react';
import { investorView } from '../utils/investorPresentation';

/**
 * Is the app being shown to somebody who must not see the spread?
 *
 * Returns [on, setOn]. The store lives in investorPresentation.js — see
 * the note there on why it is a store and not a context.
 */
export default function useInvestorView() {
  const on = useSyncExternalStore(
    investorView.subscribe,
    investorView.getSnapshot,
    investorView.getServerSnapshot,
  );
  return [on, (next) => investorView.set(next)];
}
